module.exports = __webpack_public_path__ + "integration-api-logo.png?ee1343f4b30b336f8b6409195d325dcf";